module.exports = __webpack_public_path__ + "img/webnew08.8122b3de.jpg";